module.exports = __webpack_public_path__ + "static/media/Rococo-style-portrait-345273.2b6162ed.jpg";